import cn from '@/lib/cs';
import React from 'react';

const SoundIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<g clipPath="url(#a)">
			<path
				fill="currentColor"
				d="m20.7 0-2.4.8h-2.5l-2.4.7-2.4.4-2.5-.2L7 3l-.6 1.5v2l-.3 2v2l.2 2.1-.4 2 .6 2.1H4.4l-2 1-1.7 1.6-.7 2L.5 23l1.9.8 2 .2 2.2-1.1 1.6-1.6.7-2.1.3-2-.2-2 .2-2.1-.4-2L8.9 9l2.5-.4 2.4-.2 2.5-.3 2.4-.3 2.6-.7v2.2l-.3 2 .3 2v2l-2 .3-2.4.5-1.7 1.7-.4 2.2.7 1.7 1.7 1h2l2.2-1 1.7-1.6.3-2 .1-2.3v-2.2l.5-2.2-.4-2.2V7l-.1-2.2.5-2.2L22.9.7 20.7 0Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="currentColor" d="M0 0h24v24H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default SoundIcon;
